import React, { useContext } from 'react';
import styled from 'styled-components';

import { AppContext } from 'src/components/app-context';

import { Lazy } from 'src/components/lazy';
import { ProductImage as ProductImageComponent } from 'src/components/product-image';
import { SkeletonMedia } from 'src/components/skeleton';

type Props = {
  lazyLoadImage: boolean;
  imageSize: number;
  imageSrc?: string | null;
  name: string;
  className?: string;
};

export const ProductMedia = (props: Props) => {
  const { market = { cdn: 'https://cdn.pji.nu' } } = useContext(AppContext);

  const { lazyLoadImage, imageSize, imageSrc, name } = props;

  const fallback = `${market.cdn}/product/standard/280/0.jpg`;

  return lazyLoadImage ? (
    <Lazy
      offset={0}
      placeholder={<SkeletonMedia height={imageSize} width={imageSize} />}
    >
      <ProductImage
        src={imageSrc}
        name={name}
        fallback={fallback}
        height={imageSize}
        width={imageSize}
        $size={`${imageSize}px`}
        className={props.className}
      />
    </Lazy>
  ) : (
    <ProductImage
      src={imageSrc}
      name={name}
      fallback={fallback}
      height={imageSize}
      width={imageSize}
      $size={`${imageSize}px`}
      className={props.className}
    />
  );
};

type ImageProps = {
  $size: string;
};

const ProductImage = styled(ProductImageComponent)<ImageProps>`
  width: auto;
  height: 100%;
  max-height: ${p => p.$size};
  object-fit: contain;
`;
